module.exports = __webpack_public_path__ + "img/logo-meinsponsor.0d34cce8.svg";